import DropDownTreeControl from './DropDownTreeControl';
import TreeViewControl from './TreeViewControl';
import MultipleTooltipFormControl from './MultipleTooltipFormControl';
import ListControl from './ListControl';
import FormControl from './FormControl';
import SubformControl from './SubformControl';
import "isomorphic-fetch";

window.DropDownTreeControl = DropDownTreeControl;
window.TreeViewControl = TreeViewControl;
window.MultipleTooltipFormControl = MultipleTooltipFormControl;
window.ListControl = ListControl;
window.FormControl = FormControl;
window.SubformControl = SubformControl;
